<template>
  <table class="invoice-table">
    <thead
      v-if="!isMobile">
      <tr class="row py-3 ms-0 me-0">
        <th
          class="col text-gray semi-bold small-text text-center invoice-created">
          Date
        </th>
        <th
          class="col text-gray semi-bold small-text text-center">
          Amount Paid
        </th>
        <th
          class="col text-gray semi-bold small-text text-center invoice-button">
          Invoice
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(invoice, index) in invoices"
        :key="invoice.id"
        class="row px-2 py-0 ms-0 me-0 border-top align-items-center"
        :class="{ 'bg-origami': index % 2 === 0 }">
        <td
          class="col small-text invoice-created"
          :class="{ 'text-center': !isMobile }">
          <span class="semi-bold">{{ toMonthDayYearString(invoice.date) }}</span>
          <div 
            v-if="isMobile"
            class="mt-1">
            <span 
              v-if="invoice.amountDue != invoice.amountPaid"
              class="text-danger">
              Due: {{ formatPrice(invoice.amountDue) }}
            </span>
            <span 
              v-if="invoice.amountDue == invoice.amountPaid">
              Paid: {{ formatPrice(invoice.amountPaid) }}
            </span>
          </div>
        </td>
        <td 
          v-if="!isMobile"
          class="col small-text text-center">
          {{ formatPrice(invoice.amountPaid) }}
        </td>
        <td class="col small-text text-center py-3 invoice-button">
          <BaseButton
            v-if="invoice.invoicePdf"
            small
            variant="tertiary"
            text="View Invoice"
            @click="openPdfLink(invoice.invoicePdf)"/>
          <span
            v-else
            class="small-text">
            No PDF available
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { toMonthDayYearString, formatPrice } from '@/utils/stringParsing.js'
import BaseButton from '@shared/components/ADORN/BaseButton'
import useScreenSize from '@shared/composables/screenSize'


defineProps({
  invoices: {
    type: Array,
    required: true
  }
})

const { isMobile } = useScreenSize()

const openPdfLink = (pdfLink) => {
  if (pdfLink) {
    window.open(pdfLink, '_blank')
  }
}
</script>

<style lang="scss" scoped>

.invoice-button {
  min-width: 140px;
  
  @media (min-width: 768px) {
    min-width: 170px;
  }
}

.invoice-created {
  min-width: 175px;
}

.invoice-table {
  width: 100%;
  border: $default-border;
  
  th, td {
    text-align: left;
  }

}
</style>
